document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    initSliders();
    initFavorites();
    initCollectionPageFavorites();
    initSubfilters();
    initFAQ();
    initBasketForm();
    initQuantityControls();
    initCartFunctionality();
    initNewsletterModal();
    initProductPageBuyButton();
    initBackgroundColorObserver();
    initJournalFilter();
    initProductAccordions();
    initMegaMenu();
    initSignInPopup();
    initTextSplitAnimation();
    initDailyMenuScrollToggle();
    initSmoothScroll();
    initCustomSelects();
  }, 100);
});

/* =========================
   Helpers (responsive / pagination)
========================= */
const isMobile = () => window.matchMedia('(max-width: 1023px)').matches;

function ensurePaginationEl(root) {
  let el = root.querySelector('.swiper-pagination');
  if (!el) {
    el = document.createElement('div');
    el.className = 'swiper-pagination';
    root.appendChild(el);
  }
  return el;
}

/* Global function to update swiper arrows after filtering */
window.updateSwiperArrowsAfterFilter = function () {
  // Update all swipers on the page
  document.querySelectorAll('.swiper').forEach(swiperEl => {
    if (!swiperEl.swiper) return;

    const swiper = swiperEl.swiper;
    const visibleSlides = Array.from(swiper.slides).filter(slide => {
      const style = window.getComputedStyle(slide);
      return style.display !== 'none' && style.visibility !== 'hidden';
    });

    const onMobile = isMobile();
    const slidesPerView = typeof swiper.params.slidesPerView === 'number' ? swiper.params.slidesPerView : 1;
    const shouldShowArrows = !onMobile && visibleSlides.length > slidesPerView;

    // Hide/show navigation arrows
    if (swiper.navigation?.nextEl) {
      swiper.navigation.nextEl.style.display = shouldShowArrows ? 'block' : 'none';
    }
    if (swiper.navigation?.prevEl) {
      swiper.navigation.prevEl.style.display = shouldShowArrows ? 'block' : 'none';
    }

    // Update swiper state
    swiper.allowTouchMove = visibleSlides.length > slidesPerView;

    // Update pagination on mobile
    if (onMobile && swiper.pagination?.el) {
      swiper.pagination.el.style.display = visibleSlides.length > slidesPerView ? 'block' : 'none';
    }

    // Recalculate swiper
    swiper.update();
    if (typeof lockSwiperHeight === 'function') {
      lockSwiperHeight(swiper);
    }
  });
};

/* 🔧 JS helperi: zaključavanje visine swiper-a po najvišoj kartici + prostor za paginaciju */
function lockSwiperHeight(sw) {
  if (!sw || !sw.el) return;

  if (!isMobile()) {
    sw.el.style.minHeight = '';
    sw.el.style.paddingBottom = '';
    return;
  }

  let maxH = 0;
  sw.slides.forEach(s => { maxH = Math.max(maxH, s.offsetHeight || 0); });

  // add pagination if visible
  const pagShown = sw.pagination && sw.pagination.el &&
    getComputedStyle(sw.pagination.el).display !== 'none';
  const pagH = pagShown ? sw.pagination.el.offsetHeight : 0;

  sw.el.style.minHeight = (maxH + pagH) + 'px';
}

function reservePaginationSpace(sw) {
  if (!sw || !sw.el) return;
  if (!isMobile()) { sw.el.style.paddingBottom = ''; return; }
  const pagH = sw.pagination && sw.pagination.el ? sw.pagination.el.offsetHeight : 0;
  sw.el.style.paddingBottom = pagH ? (pagH + 8) + 'px' : '';
}


function initCartFunctionality() {
  if (new URLSearchParams(window.location.search).get('open_cart') === '1') {
    const cart = document.querySelector('.cart');
    if (cart) cart.classList.add('active');
    document.body.classList.add('cart-open');
    history.replaceState(null, '', '/');
  }

  // Open/Close cart
  const openCartButtons = document.querySelectorAll('.open_cart');
  const closeCartButtons = document.querySelectorAll('.close_cart');
  const cart = document.querySelector('.cart');

  openCartButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      cart.classList.add('active');
      document.body.classList.add('cart-open');
    });
  });

  closeCartButtons.forEach(button => {
    button.addEventListener('click', () => {
      cart.classList.remove('active');
      document.body.classList.remove('cart-open');
    });
  });

  // Close cart when clicking outside
  document.addEventListener('click', (e) => {
    if (cart.classList.contains('active') && !cart.contains(e.target) && !e.target.closest('.open_cart')) {
      cart.classList.remove('active');
      document.body.classList.remove('cart-open');
    }
  });

  // Quantity controls
  document.addEventListener('click', async (e) => {
    if (e.target.classList.contains('qty-increase')) {
      e.preventDefault();
      const key = e.target.dataset.key;
      console.log('Increasing quantity for:', key);

      try {
        // Get current cart to find the current quantity
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        const cartItem = cart.items.find(item => item.key === key);

        if (cartItem) {
          await updateCartItem(key, cartItem.quantity + 1);
          showCartNotification('Quantity increased!', 'success');
        }
      } catch (error) {
        console.error('Error increasing quantity:', error);
        showCartNotification('Error updating quantity', 'error');
      }
    }

    if (e.target.classList.contains('qty-decrease')) {
      e.preventDefault();
      const key = e.target.dataset.key;
      console.log('Decreasing quantity for:', key);

      try {
        // Get current cart to find the current quantity
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        const cartItem = cart.items.find(item => item.key === key);

        if (cartItem) {
          const newQuantity = cartItem.quantity - 1;
          if (newQuantity > 0) {
            await updateCartItem(key, newQuantity);
            showCartNotification('Quantity decreased!', 'success');
          } else {
            await updateCartItem(key, 0); // Remove item
            showCartNotification('Item removed from cart!', 'success');
          }
        }
      } catch (error) {
        console.error('Error decreasing quantity:', error);
        showCartNotification('Error updating quantity', 'error');
      }
    }

    if (e.target.classList.contains('remove')) {
      e.preventDefault();
      const key = e.target.dataset.key;
      console.log('Removing item:', key);

      try {
        await updateCartItem(key, 0);
        showCartNotification('Item removed from cart!', 'success');
      } catch (error) {
        console.error('Error removing item:', error);
        showCartNotification('Error removing item', 'error');
      }
    }
  });
}

// Function to update cart item via AJAX
async function updateCartItem(key, quantity) {
  try {
    console.log('Updating cart item:', key, 'to quantity:', quantity);

    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity
      })
    });

    if (response.ok) {
      const cart = await response.json();
      console.log('Cart updated successfully:', cart);

      // Update the display
      await updateCartDisplay();

      // Update cart count in header
      updateCartCount(cart.item_count);

      return cart;
    } else {
      const errorText = await response.text();
      console.error('Error updating cart:', response.status, errorText);
      throw new Error(`Cart update failed: ${response.status}`);
    }
  } catch (error) {
    console.error('Error updating cart item:', error);
    throw error;
  }
}

// Function to update cart display
async function updateCartDisplay() {
  try {
    console.log('Updating cart display...');
    const response = await fetch('/cart.js');
    const cart = await response.json();
    console.log('Cart data:', cart);

    // Target the custom cart system
    const cartContainer = document.querySelector('.cart .items');
    console.log('Cart container:', cartContainer);

    if (!cartContainer) {
      console.warn('Cart container not found');
      return;
    }

    // Update cart header count
    const cartHeader = document.querySelector('.cart .cart-header span');
    if (cartHeader) {
      cartHeader.innerHTML = `${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}`;
      console.log('Updated cart header count:', cart.item_count);
    }

    // Clear existing items
    cartContainer.innerHTML = '';
    console.log('Cleared existing cart items');

    if (cart.items.length > 0) {
      console.log('Adding cart items:', cart.items.length);

      // Add updated items - show as single items with quantity
      cart.items.forEach((item, lineIndex) => {
        const itemElement = createCartItemElement(item, lineIndex + 1);
        cartContainer.appendChild(itemElement);
        console.log(`Added item to cart: ${item.product_title} (qty: ${item.quantity})`);
      });

    } else {
      console.log('Cart is empty');
      const emptyElement = document.createElement('div');
      emptyElement.className = 'cart-empty';
      emptyElement.innerHTML = '<p>Your cart is empty</p>';
      cartContainer.appendChild(emptyElement);
    }

    // Update cart total
    updateCartTotal(cart);

  } catch (error) {
    console.error('Error updating cart display:', error);
  }

}

// Replace your existing createCartItemElement function with this:
function createCartItemElement(item, lineIndex) {
  const div = document.createElement('div');
  div.className = 'cart-item';
  div.setAttribute('role', 'listitem');
  div.setAttribute('data-cart-item', item.key);
  div.setAttribute('data-line', lineIndex);

  const imageUrl = item.image ? item.image.replace('.jpg', '_200x.jpg').replace('.png', '_200x.png') : '/assets/product-placeholder.svg';

  // Check if it's a subscription
  const isSubscription = item.selling_plan_allocation !== null;

  // Calculate total price for the line (item price × quantity)
  const lineTotalPrice = item.final_price * item.quantity;
  const originalLineTotalPrice = item.original_price * item.quantity;

  div.innerHTML = `
    <div class="image_wrap">
      <img src="${imageUrl}" alt="${item.product_title}" />
    </div>
    
    <div class="item-details">
      
      <p class="item-title">${item.product_title}</p>
      
      ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="item-variant">${item.variant_title}</p>` : ''}
      
      <p class="item-price">
        ${item.original_price !== item.final_price ?
      `<span class="item-price--original">${formatMoney(originalLineTotalPrice)}</span>
           <span class="item-price--final">${formatMoney(lineTotalPrice)}</span>` :
      formatMoney(lineTotalPrice)
    }
        ${item.selling_plan_allocation ? ` / ${item.selling_plan_allocation.selling_plan.name}` : ''}
      </p>

      <div class="qty">
        <div class="qty-controls" aria-label="Quantity controls">
          <button type="button" 
                  class="qty-decrease" 
                  data-key="${item.key}" 
                  data-line="${lineIndex}" 
                  data-step="-1" 
                  aria-label="Decrease">−</button>
          
          <span class="qty-number" aria-live="polite">${item.quantity}</span>
          
          <button type="button" 
                  class="qty-increase" 
                  data-key="${item.key}" 
                  data-line="${lineIndex}" 
                  data-step="1" 
                  aria-label="Increase">+</button>
        </div>
        
        <button type="button" 
                class="remove" 
                data-key="${item.key}" 
                data-line="${lineIndex}" 
                data-remove="all" 
                aria-label="Remove item">X</button>
      </div>
    </div>
  `;

  return div;
}

// Function to update cart total
function updateCartTotal(cart) {
  const totalSection = document.querySelector('.cart .total');

  if (!totalSection) {
    console.warn('Cart total section not found');
    return;
  }

  if (cart.items.length > 0) {
    const existingNote = totalSection.querySelector('#CartNote');
    const savedNote = existingNote ? existingNote.value : cart.note || '';

    totalSection.innerHTML = `
      <cart-note>
        <label class="cart-note__label" for="CartNote">Gift Message</label>
        <textarea id="CartNote" name="note" form="CartGiftCheckout" rows="3" class="cart-note__textarea">${savedNote}</textarea>
      </cart-note>

      ${cart.total_discount > 0 ? `
        <div class="cart-subtotal">
          Subtotal: ${formatMoney(cart.original_total_price)}
        </div>
        <div class="cart-discounts">
          ${cart.cart_level_discount_applications.map(discount =>
      `<div class="cart-discount">${discount.title}: -${formatMoney(discount.total_allocated_amount)}</div>`
    ).join('')}
        </div>
      ` : ''}

      <div class="price">Total: ${formatMoney(cart.total_price)}</div>


      <form action="/cart" method="post" id="CartGiftCheckout" novalidate>
        <button type="submit" name="checkout" class="checkout-btn" ${cart.item_count === 0 ? 'disabled' : ''}>
          CHECKOUT
        </button>
      </form>
    `;
  } else {
    totalSection.innerHTML = `
      <a href="/collections/all" class="checkout-btn">
        CONTINUE SHOPPING
      </a>
    `;
  }
}

// Function to update cart count in header
function updateCartCount(count) {
  const cartCountElement = document.querySelector('.header-block__cart-count');
  if (cartCountElement) {
    if (count > 0) {
      cartCountElement.textContent = count;
      cartCountElement.style.display = 'flex';
    } else {
      cartCountElement.style.display = 'none';
    }
  }
}

// Function to show cart notifications
function showCartNotification(message, type = 'success') {
  // Remove any existing notifications
  document.querySelectorAll('.cart-notification').forEach(n => n.remove());

  const notification = document.createElement('div');
  notification.className = `cart-notification cart-notification--${type}`;
  notification.textContent = message;

  Object.assign(notification.style, {
    position: 'fixed',
    top: '20px',
    right: '20px',
    background: type === 'success' ? '#DBD198' : '#2A2E6D',
    color: type === 'success' ? '#2A2E6D' : '#DBD198',
    fontFamily: 'fold-grotesque-medium-pro',
    padding: '12px 20px',
    borderRadius: '4px',
    zIndex: '10001',
    fontSize: '14px',
    fontWeight: '500',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    transform: 'translateX(100%)',
    transition: 'transform 0.3s ease',
    maxWidth: '300px',
    wordWrap: 'break-word'
  });

  document.body.appendChild(notification);

  // Animate in
  setTimeout(() => {
    notification.style.transform = 'translateX(0)';
  }, 100);

  // Animate out and remove
  setTimeout(() => {
    notification.style.transform = 'translateX(100%)';
    setTimeout(() => notification.remove(), 300);
  }, 2500);
}

// Replace your existing formatMoney function with this:
function formatMoney(cents) {
  // cents is already in cents from Shopify API, so divide by 100 to get dollars
  const dollars = (cents / 100).toFixed(2);
  return `$${dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
}

/* =========================
   Daily menu hide/show
========================= */
function initDailyMenuScrollToggle() {
  const dailyMenuNav = document.querySelector('.daily-menu-nav');
  if (!dailyMenuNav) return;

  let lastScrollTop = 0;
  const scrollThreshold = 50;

  function handleScroll() {
    const currentScrollTop = Math.max(0, window.pageYOffset || document.documentElement.scrollTop);
    if (Math.abs(currentScrollTop - lastScrollTop) > scrollThreshold) {
      if (currentScrollTop > lastScrollTop && currentScrollTop > 100) {
        dailyMenuNav.classList.add('hidde-nav');
      } else if (currentScrollTop < lastScrollTop) {
        dailyMenuNav.classList.remove('hidde-nav');
      }
      lastScrollTop = currentScrollTop;
    }
  }

  let ticking = false;
  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => { handleScroll(); ticking = false; });
      ticking = true;
    }
  }, { passive: true });

  dailyMenuNav.classList.remove('hidden');
}

/* =========================
   Split text animation
========================= */
function initTextSplitAnimation() {
  const splitTextElements = document.querySelectorAll('[data-split-text]');
  const isMobile = window.innerWidth <= 480;

  if (isMobile) {
    return;
  }

  splitTextElements.forEach(el => splitIntoLines(el));

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.querySelectorAll('.text-split-line').forEach(line => line.classList.add('animate-in'));
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2, rootMargin: '0px 0px -50px 0px' });

  splitTextElements.forEach(el => observer.observe(el));
}

function splitIntoLines(element) {
  if (element.querySelector('a, strong, em, span')) return;
  const originalText = element.textContent.trim();
  const words = originalText.split(' ');
  element.innerHTML = '';

  const tempSpan = document.createElement('span');
  tempSpan.style.visibility = 'hidden';
  tempSpan.style.position = 'absolute';
  tempSpan.style.whiteSpace = 'nowrap';

  let lines = [];
  let currentLine = [];

  words.forEach((word, index) => {
    currentLine.push(word);
    tempSpan.textContent = currentLine.join(' ');
    element.appendChild(tempSpan);

    const tooWide = tempSpan.offsetWidth > element.offsetWidth;
    element.removeChild(tempSpan);

    if (tooWide) {
      currentLine.pop();
      if (currentLine.length) lines.push(currentLine.join(' '));
      currentLine = [word];
    }
    if (index === words.length - 1) lines.push(currentLine.join(' '));
  });

  element.innerHTML = '';
  lines.forEach(lineText => {
    const line = document.createElement('span');
    line.className = 'text-split-line';
    line.innerHTML = `<span class="line-inner">${lineText}</span>`;
    element.appendChild(line);
  });
}

/* =========================
   Mega menu
========================= */
function initMegaMenu() {
  const primaryLinks = document.querySelectorAll('.nav-mega-menu-block__primary-link');
  const columnsWrappers = document.querySelectorAll('.nav-mega-menu-block__columns-wrapper');
  const column3Groups = document.querySelectorAll('.nav-mega-menu-block__group--column-3');
  const featuredSections = document.querySelectorAll('.nav-mega-menu-block__featured');

  primaryLinks.forEach(link => {
    link.addEventListener('mouseenter', () => {
      const handle = link.getAttribute('data-menu');
      [columnsWrappers, column3Groups, featuredSections].forEach(list =>
        list.forEach(el => el.classList.toggle('active', el.getAttribute('data-menu') === handle))
      );
    });
  });

  const openBtn = document.getElementById('open-megamenu');
  const closeBtn = document.getElementById('close-megamenu');
  const block = document.querySelector('.nav-mega-menu-block');

  if (openBtn && closeBtn && block) {
    openBtn.addEventListener('click', () => {
      block.classList.remove('hidden', 'slide-up-to-top');
      block.classList.add('slide-down-from-top');
    });
    closeBtn.addEventListener('click', () => {
      block.classList.remove('slide-down-from-top');
      block.classList.add('slide-up-to-top');
      setTimeout(() => {
        block.classList.add('hidden');
        block.classList.remove('slide-up-to-top');
      }, 500);
    });
  }
}

/* =========================
   Sign-in popup
========================= */
function initSignInPopup() {
  const openBtn = document.getElementById('open-signin-popup');
  const closeBtn = document.getElementById('close-signup-popup');
  const overlay = document.getElementById('signup-overlay');
  const popup = document.getElementById('signup-popup');
  if (!openBtn || !closeBtn || !overlay || !popup) return;

  const open = (e) => {
    e?.preventDefault();
    document.body.classList.add('signup-popup-visible');
    setTimeout(() => popup.querySelector('input[type="email"]')?.focus(), 300);
  };
  const close = () => {
    document.body.classList.remove('signup-popup-visible');
    popup.querySelectorAll('input').forEach(input => input.type === 'checkbox' ? (input.checked = false) : (input.value = ''));
    popup.querySelectorAll('.popup-error').forEach(el => { el.textContent = ''; el.hidden = true; });
    popup.querySelectorAll('.popup-button').forEach(btn => { btn.disabled = false; btn.classList.remove('loading'); });
  };

  openBtn.addEventListener('click', open);
  closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', close);
  document.addEventListener('keydown', (e) => e.key === 'Escape' && document.body.classList.contains('signup-popup-visible') && close());

  function showError(errorEl, message) {
    errorEl.textContent = message;
    errorEl.hidden = false;
  }

  function extractShopifyError(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const el = doc.querySelector('.errors li, .note.errors, [data-errors] li, ul.errors li');
    return el ? el.textContent.trim() : null;
  }

  async function handleFormSubmit(e) {
    e.preventDefault();
    const form = e.currentTarget;
    const isLogin = form.id === 'login-form';
    const btn = form.querySelector('.popup-button');
    const errorEl = form.querySelector('.popup-error');

    errorEl.hidden = true;
    errorEl.textContent = '';
    btn.disabled = true;
    btn.classList.add('loading');
    btn.textContent = isLogin ? 'Signing In...' : 'Creating Account...';

    try {
      const res = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        redirect: 'follow',
      });

      const finalUrl = res.url || '';
      const isError = isLogin
        ? finalUrl.includes('/account/login')
        : finalUrl.includes('/account/register');

      if (!isError) {
        window.location.reload();
        return;
      }

      const html = await res.text();
      const msg = extractShopifyError(html) || (isLogin
        ? 'Incorrect email or password.'
        : 'Unable to create account. Email may already be in use.');
      showError(errorEl, msg);
    } catch (_) {
      showError(errorEl, 'Something went wrong. Please try again.');
    }

    btn.disabled = false;
    btn.classList.remove('loading');
    btn.textContent = isLogin ? 'ACCESS ACCOUNT' : 'CREATE ACCOUNT';
  }

  ['login-form', 'register-form'].forEach(id => {
    const form = document.getElementById(id);
    if (form) form.addEventListener('submit', handleFormSubmit);
  });
}

/* =========================
   Swipers
========================= */
function initSliders() {
  // HERO
  (function () {
    const heroEl = document.querySelector('.slider-block .swiper');
    if (!heroEl) return;

    const slideCount = heroEl.querySelectorAll('.swiper-slide').length;
    const multi = slideCount > 1;

    const nextEl = heroEl.querySelector('.swiper-button-next') || null;
    const prevEl = heroEl.querySelector('.swiper-button-prev') || null;
    const pagEl = heroEl.querySelector('.swiper-pagination') || null;

    if (!multi) [nextEl, prevEl, pagEl].forEach(el => el && (el.style.display = 'none'));

    function prepHeroCard(card) {
      if (!card || card.dataset.heroPrepped) return;
      card.dataset.heroPrepped = '1';

      const h2 = card.querySelector('.text-intro-block__intro-title');
      if (h2) {
        const segments = h2.innerHTML.split(/<br\s*\/?>/i);
        h2.innerHTML = segments.map(seg => {
          const words = seg.replace(/<[^>]+>/g, '').trim().split(/\s+/).filter(Boolean);
          return words.map(w =>
            `<span class="hw-outer"><span class="hw-inner">${w}</span></span>`
          ).join(' ');
        }).join('<br>');
      }

      const p = card.querySelector('.text-intro-block__description');
      if (p) {
        const brSegments = p.innerHTML.split(/<br\s*\/?>/i);
        const processedParts = [];

        brSegments.forEach((seg, si) => {
          const text = seg.replace(/<[^>]+>/g, '').trim();
          if (!text) return;

          const words = text.split(/\s+/).filter(Boolean);
          p.innerHTML = words.map(w => `<span>${w}</span>`).join(' ');
          const wSpans = [...p.querySelectorAll('span')];
          const lines = [];
          let cur = [];
          let lastTop = null;
          wSpans.forEach(s => {
            const t = s.offsetTop;
            if (lastTop !== null && t > lastTop + 2) { lines.push(cur); cur = []; }
            cur.push(s.textContent);
            lastTop = t;
          });
          if (cur.length) lines.push(cur);

          const isNewSegment = si > 0 && processedParts.length > 0;
          processedParts.push(
            (lines.length > 1 ? lines : [[text]]).map((l, li) =>
              `<span class="hl-outer${isNewSegment && li === 0 ? ' hl-outer--break' : ''}"><span class="hl-inner">${l.join(' ')}</span></span>`
            ).join('')
          );
        });

        p.innerHTML = processedParts.join('');
      }

      const btn = card.querySelector('.monas-featured-boxes-block__item-button');
      if (btn) {
        const outer = document.createElement('span');
        const inner = document.createElement('span');
        outer.className = 'hero-btn-outer';
        inner.className = 'hero-btn-inner';
        btn.parentNode.insertBefore(outer, btn);
        outer.appendChild(inner);
        inner.appendChild(btn);
      }
    }

    function resetHeroCard(card) {
      if (!card) return;
      const allEls = [...card.querySelectorAll('.hw-inner, .hl-inner, .hero-btn-inner')];
      card.classList.remove('is-animating');
      allEls.forEach(el => { el.style.transition = 'none'; });
      void card.offsetWidth;
      allEls.forEach(el => { el.style.transition = ''; });
    }

    function animateHeroCard(card) {
      if (!card) return;

      const words = card.querySelectorAll('.hw-inner');
      const lines = card.querySelectorAll('.hl-inner');
      const btnInner = card.querySelector('.hero-btn-inner');

      words.forEach((el, i) => {
        el.style.transitionDelay = `${(i * 0.055).toFixed(3)}s`;
      });
      const baseDelay = Math.min(words.length * 0.055, 0.35);
      lines.forEach((el, i) => {
        el.style.transitionDelay = `${(baseDelay + i * 0.1).toFixed(3)}s`;
      });
      if (btnInner) {
        btnInner.style.transitionDelay = `${(baseDelay + lines.length * 0.1 + 0.05).toFixed(3)}s`;
      }

      card.classList.add('is-animating');
    }

    new Swiper(heroEl, {
      loop: false,
      allowTouchMove: multi,
      autoplay: false,
      speed: 900,
      effect: 'fade',
      navigation: multi && nextEl && prevEl ? { nextEl, prevEl } : {},
      pagination: multi && pagEl ? { el: pagEl, clickable: true } : {},
      on: {
        init(sw) {
          sw.slides.forEach(slide => {
            const card = slide.querySelector('.hero-card');
            if (card) prepHeroCard(card);
          });
          const activeCard = sw.slides[sw.activeIndex]?.querySelector('.hero-card');
          resetHeroCard(activeCard);
          animateHeroCard(activeCard);

          const mobileCard = document.querySelector('.hero-mobile-card-wrapper .hero-card');
          if (mobileCard) {
            prepHeroCard(mobileCard);
            resetHeroCard(mobileCard);
            animateHeroCard(mobileCard);
          }
        },
        slideChangeTransitionStart(sw) {
          sw.slides.forEach(s => s.classList.remove('is-reveal-entering'));
          const active = sw.slides[sw.activeIndex];
          if (active) {
            void active.offsetWidth;
            active.classList.add('is-reveal-entering');
            resetHeroCard(active.querySelector('.hero-card'));

            const mobileCard = document.querySelector('.hero-mobile-card-wrapper .hero-card');
            const sourceCard = active.querySelector('.hero-card');
            if (mobileCard && sourceCard) {
              mobileCard.innerHTML = sourceCard.innerHTML;
              mobileCard.className = sourceCard.className.replace('is-animating', '').trim();
              resetHeroCard(mobileCard);
            }
          }
          setTimeout(() => {
            const card = active?.querySelector('.hero-card');
            if (card) animateHeroCard(card);
            const mobileCard = document.querySelector('.hero-mobile-card-wrapper .hero-card');
            if (mobileCard) animateHeroCard(mobileCard);
          }, 1080);
        },
      },
    });
  })();

  // PRODUCTS LIST (ne home-collection)
  document.querySelectorAll('.products-list-block .swiper').forEach((el) => {
    if (el.swiper) return;
    if (el.closest('.home-collection-block')) return; // te radi tabs modul

    const block = el.closest('.products-list-block');
    const isJournal = block && block.classList.contains('four-items-products-list');

    const nextEl = el.querySelector('.swiper-button-next') || el.parentElement.querySelector('.swiper-button-next');
    const prevEl = el.querySelector('.swiper-button-prev') || el.parentElement.querySelector('.swiper-button-prev');
    const pagEl = ensurePaginationEl(el);
    const onMobile = isMobile();

    const sw = new Swiper(el, {
      loop: false,
      spaceBetween: 10,
      speed: 800,
      navigation: (!onMobile && nextEl && prevEl) ? { nextEl, prevEl } : {},
      pagination: onMobile && pagEl ? { el: pagEl, clickable: true } : {},
      breakpoints: {
        320: { slidesPerView: 2 },                 // ← dve kartice na mobilu
        640: { slidesPerView: 2 },
        1024: { slidesPerView: isJournal ? 4 : 3 },
      },
      on: {
        init: function () {
          const spv = typeof this.params.slidesPerView === 'number' ? this.params.slidesPerView : 1;
          if (this.slides.length <= spv) {
            this.allowTouchMove = false;
            if (this.navigation?.nextEl) this.navigation.nextEl.style.display = 'none';
            if (this.navigation?.prevEl) this.navigation.prevEl.style.display = 'none';
            if (this.pagination?.el) this.pagination.el.style.display = 'none';
          }
          lockSwiperHeight(this);
          reservePaginationSpace(this);
        },
        resize: function () {
          lockSwiperHeight(this);
          reservePaginationSpace(this);
        },
        imagesReady: function () {
          lockSwiperHeight(this);
        },
        slideChangeTransitionEnd: function () {
          lockSwiperHeight(this);
        }
      }
    });

    if (onMobile) el.style.overflow = 'visible';
  });

  // Testimonials
  new Swiper('.product-testimonials-block__swiper', {
    loop: true,
    slidesPerView: 1,
    speed: 800,
    navigation: { nextEl: '.product-testimonials-block__wrapper .swiper-button-next' },
  });

  // Catering
  new Swiper('.slider-catering .swiper', {
    slidesPerView: 1.2,
    spaceBetween: 10,
    centeredSlides: false,
    breakpoints: {
      1024: { slidesPerView: 2.5, spaceBetween: 10, slidesOffsetAfter: 50 }
    },
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
  });
}

/* =========================
   HOME COLLECTION tabs + Swiper
========================= */
(function () {
  window.initHomeCollectionTabs = function initHomeCollectionTabs() {
    const blocks = document.querySelectorAll('.products-list-block .home-collection-block');
    if (!blocks.length) return;

    const prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const instances = new Map();
    const makeKey = (bid, tag) => `${bid}::${tag}`;
    const getPane = (blockEl, tag) => blockEl.querySelector(`.swiper-${tag}`);

    // Desktop-only minHeight measure; on mobile we remove inline min-height
    function measureMaxHeight(blockEl) {
      if (isMobile()) { blockEl.style.minHeight = ''; return; }
      let maxH = 0;
      blockEl.querySelectorAll('.tabpane').forEach(p => {
        const prev = { d: p.style.display, v: p.style.visibility, pos: p.style.position };
        p.style.display = 'block'; p.style.visibility = 'hidden'; p.style.position = 'absolute';
        maxH = Math.max(maxH, p.offsetHeight);
        p.style.display = prev.d || ''; p.style.visibility = prev.v || ''; p.style.position = prev.pos || '';
      });
      blockEl.style.minHeight = maxH ? (maxH + 'px') : '';
    }

    // Liquid's tag_handle is corrupted by the inner badge-processing loop, so we
    // find nav buttons by DOM position (immediate siblings of their swiper pane).
    function getPaneNavEls(pane) {
      const prev = pane?.nextElementSibling?.classList.contains('swiper-button-prev') ? pane.nextElementSibling : null;
      const next = prev?.nextElementSibling?.classList.contains('swiper-button-next') ? prev.nextElementSibling : null;
      return { prevEl: prev, nextEl: next };
    }

    function showNav(blockEl, tag) {
      blockEl.querySelectorAll('.swiper-button-prev, .swiper-button-next').forEach(b => b.style.display = 'none');
      const pane = getPane(blockEl, tag);
      const { prevEl, nextEl } = getPaneNavEls(pane);
      if (nextEl) nextEl.style.display = isMobile() ? 'none' : 'block';
      if (prevEl) prevEl.style.display = isMobile() ? 'none' : 'block';
    }

    function createSwiper(blockEl, blockId, tag) {
      const pane = getPane(blockEl, tag);
      if (!pane) return null;
      const key = makeKey(blockId, tag);
      if (instances.get(key)) return instances.get(key);

      const { prevEl, nextEl } = getPaneNavEls(pane);
      const pagEl = ensurePaginationEl(pane);
      const onMobile = isMobile();

      const sw = new Swiper(pane, {
        slidesPerView: 2,                 // ← dve kartice na mobilu
        spaceBetween: 15,
        navigation: {},
        watchOverflow: false,
        pagination: onMobile && pagEl ? { el: pagEl, clickable: true } : {},
        observer: true,
        observeParents: true,
        breakpoints: {
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        },
        on: {
          init: function () {
            const spv = typeof this.params.slidesPerView === 'number' ? this.params.slidesPerView : 2;
            const locked = this.slides.length <= spv;
            if (locked) {
              this.allowTouchMove = false;
              if (nextEl) nextEl.style.setProperty('display', 'none', 'important');
              if (prevEl) prevEl.style.setProperty('display', 'none', 'important');
              if (this.pagination?.el) this.pagination.el.style.display = 'none';
            }
            lockSwiperHeight(this);
            reservePaginationSpace(this);
          },
          resize: function () {
            lockSwiperHeight(this);
            reservePaginationSpace(this);
          },
          imagesReady: function () {
            lockSwiperHeight(this);
          },
          slideChangeTransitionEnd: function () {
            lockSwiperHeight(this);
          }
        }
      });

      instances.set(key, sw);

      if (!onMobile && nextEl) nextEl.addEventListener('click', () => {
        if (!sw.enabled) sw.enable();
        sw.slideNext();
      });
      if (!onMobile && prevEl) prevEl.addEventListener('click', () => {
        if (!sw.enabled) sw.enable();
        sw.slidePrev();
      });

      if (onMobile) pane.style.overflow = 'visible';

      return sw;
    }

    function getDur(blockEl, varName, fallback) {
      const v = getComputedStyle(blockEl).getPropertyValue(varName);
      const s = String(v).trim();
      const ms = s.endsWith('ms') ? parseFloat(s) : s.endsWith('s') ? parseFloat(s) * 1000 : parseFloat(s) || 0;
      return ms || fallback;
    }

    function showPane(blockEl, blockId, tag, dir) {
      const ENTER_MS = getDur(blockEl, '--hc-enter-ms', 420);
      const EXIT_MS = getDur(blockEl, '--hc-exit-ms', 340);

      const pane = getPane(blockEl, tag);
      if (!pane) return;

      blockEl.style.setProperty('--dir', (dir && dir < 0) ? '-1' : '1');
      showNav(blockEl, tag);

      const prev = blockEl.querySelector('.tabpane.is-active');
      if (prev && prev !== pane) {
        prev.classList.remove('anim-enter');
        if (!prefersReduced) {
          prev.classList.add('anim-exit');
          setTimeout(() => {
            prev.classList.remove('anim-exit', 'is-active');
            prev.style.display = 'none';
            prev.style.visibility = 'hidden';
            prev.style.opacity = '0';
          }, EXIT_MS + 20);
        } else {
          prev.classList.remove('is-active');
          prev.style.display = 'none';
        }
      }

      pane.style.display = 'block';
      pane.style.visibility = 'visible';
      pane.style.opacity = '1';
      pane.classList.add('is-active');
      pane.classList.remove('anim-exit');

      const sw = createSwiper(blockEl, blockId, tag);
      requestAnimationFrame(() => {
        if (sw) {
          sw.update();
          lockSwiperHeight(sw);
          reservePaginationSpace(sw);
        }
      });

      if (!prefersReduced) {
        void pane.offsetWidth;
        pane.classList.add('anim-enter');
        setTimeout(() => pane.classList.remove('anim-enter'), ENTER_MS + 20);
      }

      measureMaxHeight(blockEl);
    }

    // wire-up
    document.querySelectorAll('.products-list-block__filters-list').forEach(list => {
      const buttons = list.querySelectorAll('button[data-filter][data-block]');
      if (!buttons.length) return;

      const blockId = buttons[0].getAttribute('data-block');
      const blockEl = document.getElementById(`block-${blockId}`);
      if (!blockEl || blockEl.dataset.tabsWired === '1') return;
      blockEl.dataset.tabsWired = '1';

      blockEl.querySelectorAll('.swiper').forEach(el => el.classList.add('tabpane'));

      const showFirst = () => showPane(blockEl, blockId, buttons[0].getAttribute('data-filter'), 1);
      buttons.forEach(btn => {
        btn.addEventListener('click', () => {
          const nextTag = btn.getAttribute('data-filter');
          const btns = Array.from(buttons);
          const nextIdx = btns.indexOf(btn);
          const prevPane = blockEl.querySelector('.tabpane.is-active');
          const prevTag = prevPane ? prevPane.getAttribute('data-filter') : nextTag;
          const prevIdx = btns.findIndex(b => b.getAttribute('data-filter') === prevTag);
          const dir = Math.sign(nextIdx - prevIdx) || 1;

          buttons.forEach(b => b.classList.add('products-list-block__title--light'));
          btn.classList.remove('products-list-block__title--light');

          showPane(blockEl, blockId, nextTag, dir);
        });
      });

      showFirst();

      // Re-measure on resize: desktop calc, mobile cleanup
      window.addEventListener('resize', () => measureMaxHeight(blockEl));
    });
  };

  window.initHomeCollectionTabs();
  document.addEventListener('shopify:section:load', () => { try { window.initHomeCollectionTabs(); } catch (_) { } });
  document.addEventListener('shopify:section:select', () => { try { window.initHomeCollectionTabs(); } catch (_) { } });
})();

/* =========================
   Favorites (heart)
========================= */
function initFavorites() {
  const selectors = [
    { wrapper: '.products-list-block__slide', fav: '.products-list-block__favourites', favSelected: '.products-list-block__favourites--selected' },
    { wrapper: '.product-card', fav: '.product-card__favourites', favSelected: '.product-card__favourites--selected' },
    { wrapper: '.product-favorites-wrapper', fav: '.products-list-block__favourites', favSelected: '.products-list-block__favourites--selected' },
  ];

  selectors.forEach(({ wrapper, fav, favSelected }) => {
    document.querySelectorAll(wrapper).forEach(slide => {
      const favEl = slide.querySelector(fav);
      const favSelectedEl = slide.querySelector(favSelected);
      if (!favEl || !favSelectedEl) return;

      const productId = getProductIdFromSlide(slide);
      if (isProductFavorited(productId)) { favEl.style.display = 'none'; favSelectedEl.style.display = 'block'; }
      else { favEl.style.display = 'block'; favSelectedEl.style.display = 'none'; }

      favEl.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); addToFavorites(productId); toggleFavorite(favEl, favSelectedEl); });
      favSelectedEl.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); removeFromFavorites(productId); toggleFavorite(favSelectedEl, favEl); });
    });
  });

  function toggleFavorite(hideEl, showEl) { hideEl.style.display = 'none'; showEl.style.display = 'block'; }

  function getProductIdFromSlide(slide) {
    let productId = slide.dataset.productId;
    if (!productId) productId = slide.querySelector('.products-list-block__product-form-submit')?.dataset.productId;
    if (!productId) productId = document.querySelector('[data-product-id]')?.dataset.productId;
    if (!productId) {
      const productLink = slide.querySelector('a[href*="/products/"]');
      const m = productLink?.href.match(/\/products\/([^\/\?]+)/);
      if (m) productId = m[1];
    }
    return productId;
  }

  function isProductFavorited(productId) { return getFavorites().includes(productId); }
  function getFavorites() { return JSON.parse(localStorage.getItem('talbot_favorites') || '[]'); }

  function addToFavorites(productId) {
    if (!productId) return;
    const favorites = getFavorites();
    if (!favorites.includes(productId)) {
      favorites.push(productId);
      localStorage.setItem('talbot_favorites', JSON.stringify(favorites));
      showFavoriteNotification('Added to favorites!', 'success');
      updateFavoritesCount();
    }
  }

  function removeFromFavorites(productId) {
    if (!productId) return;
    const favorites = getFavorites().filter(id => id !== productId);
    localStorage.setItem('talbot_favorites', JSON.stringify(favorites));
    showFavoriteNotification('Removed from favorites!', 'info');
    updateFavoritesCount();
  }

  function showFavoriteNotification(message, type = 'success') {
    const n = document.createElement('div');
    n.className = `favorite-notification favorite-notification--${type}`;
    n.textContent = message;
    Object.assign(n.style, {
      position: 'fixed', top: '20px', right: '20px',
      background: type === 'success' ? '#DBD198' : '#2A2E6D',
      color: type === 'success' ? '#2A2E6D' : '#DBD198',
      fontFamily: 'fold-grotesque-medium-pro',
      padding: '12px 20px', borderRadius: '4px', zIndex: '10000',
      fontSize: '14px', boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
      transform: 'translateX(100%)', transition: 'transform 0.3s ease'
    });
    document.body.appendChild(n);
    setTimeout(() => { n.style.transform = 'translateX(0)'; }, 100);
    setTimeout(() => { n.style.transform = 'translateX(100%)'; setTimeout(() => n.remove(), 300); }, 3000);
  }

  function updateFavoritesCount() {
    const count = getFavorites().length;
    const el = document.querySelector('.header-favorites-count');
    if (el) { el.textContent = count; el.style.display = count > 0 ? 'block' : 'none'; }
    const drawerCount = document.getElementById('fav-drawer-count');
    if (drawerCount) drawerCount.textContent = count > 0 ? `${count} ${count === 1 ? 'item' : 'items'}` : '';
  }

  updateFavoritesCount();
}

/* Collection page hearts */
function initCollectionPageFavorites() {
  document.querySelectorAll('.product-card[data-product-id]').forEach(card => {
    const id = card.getAttribute('data-product-id');
    const fav = card.querySelector('.products-list-block__favourites:not(.products-list-block__favourites--selected)');
    const favSel = card.querySelector('.products-list-block__favourites--selected');
    if (!fav || !favSel || !id) return;

    const favorites = JSON.parse(localStorage.getItem('talbot_favorites') || '[]');
    const isFav = favorites.includes(id);
    fav.style.display = isFav ? 'none' : 'block';
    favSel.style.display = isFav ? 'block' : 'none';

    fav.addEventListener('click', (e) => {
      e.preventDefault(); e.stopPropagation();
      if (!favorites.includes(id)) { favorites.push(id); localStorage.setItem('talbot_favorites', JSON.stringify(favorites)); show('Added to favorites!', 'success'); upd(); }
      fav.style.display = 'none'; favSel.style.display = 'block';
    });

    favSel.addEventListener('click', (e) => {
      e.preventDefault(); e.stopPropagation();
      const f = favorites.filter(x => x !== id); localStorage.setItem('talbot_favorites', JSON.stringify(f)); show('Removed from favorites!', 'info'); upd();
      favSel.style.display = 'none'; fav.style.display = 'block';
    });

    function show(msg, type) {
      document.querySelectorAll('.collection-favorite-notification').forEach(n => n.remove());
      const n = document.createElement('div');
      n.className = `collection-favorite-notification collection-favorite-notification--${type}`;
      n.textContent = msg;
      Object.assign(n.style, {
        position: 'fixed', top: '20px', right: '20px', background: type === 'success' ? '#4CAF50' : '#2196F3',
        color: '#fff', padding: '12px 20px', borderRadius: '4px', zIndex: '10000', fontSize: '14px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.2)', opacity: '0', transform: 'translateX(100%)', transition: 'all .3s ease'
      });
      document.body.appendChild(n);
      setTimeout(() => { n.style.opacity = '1'; n.style.transform = 'translateX(0)'; }, 10);
      setTimeout(() => { n.style.opacity = '0'; n.style.transform = 'translateX(100%)'; setTimeout(() => n.remove(), 300); }, 3000);
    }
    function upd() {
      const countEl = document.querySelector('.header-favorites-count');
      if (countEl) {
        const favs = JSON.parse(localStorage.getItem('talbot_favorites') || '[]');
        countEl.textContent = favs.length;
        countEl.style.display = favs.length > 0 ? 'block' : 'none';
      }
    }
  });
}

/* =========================
   Subfilters
========================= */
function initSubfilters() {
  const items = document.querySelectorAll('.filter-label-wrapper__item');
  const wrap = document.querySelector('.subfilters-wrapper');
  const reset = document.querySelector('.filter-label-wrapper__reset');
  if (!wrap) return;

  const groups = wrap.querySelectorAll('.subfilters-group');

  // Helper function to update swiper arrows based on visible slides
  function updateSwiperArrows(swiperEl) {
    if (!swiperEl || !swiperEl.swiper) return;

    const swiper = swiperEl.swiper;
    const visibleSlides = Array.from(swiper.slides).filter(slide => {
      const style = window.getComputedStyle(slide);
      return style.display !== 'none' && style.visibility !== 'hidden';
    });

    const onMobile = isMobile();
    const slidesPerView = typeof swiper.params.slidesPerView === 'number' ? swiper.params.slidesPerView : 1;
    const shouldShowArrows = !onMobile && visibleSlides.length > slidesPerView;

    // Hide/show navigation arrows
    if (swiper.navigation?.nextEl) {
      swiper.navigation.nextEl.style.display = shouldShowArrows ? 'block' : 'none';
    }
    if (swiper.navigation?.prevEl) {
      swiper.navigation.prevEl.style.display = shouldShowArrows ? 'block' : 'none';
    }

    // Update swiper state
    swiper.allowTouchMove = visibleSlides.length > slidesPerView;

    // Update pagination on mobile
    if (onMobile && swiper.pagination?.el) {
      swiper.pagination.el.style.display = visibleSlides.length > slidesPerView ? 'block' : 'none';
    }

    // Recalculate swiper
    swiper.update();
    if (typeof lockSwiperHeight === 'function') {
      lockSwiperHeight(swiper);
    }
  }

  // Helper function to update all swipers on the page
  function updateAllSwipers() {
    // Update products list swipers
    document.querySelectorAll('.products-list-block .swiper').forEach(updateSwiperArrows);

    // Update home collection swipers
    document.querySelectorAll('.home-collection-block .swiper').forEach(updateSwiperArrows);

    // Update any other swipers that might be affected
    document.querySelectorAll('.swiper').forEach(swiperEl => {
      if (swiperEl.closest('.products-list-block') || swiperEl.closest('.home-collection-block')) {
        updateSwiperArrows(swiperEl);
      }
    });
  }

  items.forEach(item => {
    item.addEventListener('click', () => {
      const key = item.dataset.filter;
      items.forEach(el => el.classList.remove('filter-label-wrapper__item--active'));
      item.classList.add('filter-label-wrapper__item--active');
      groups.forEach(g => g.classList.remove('active'));
      wrap.querySelector(`.subfilters-group[data-group="${key}"]`)?.classList.add('active');

      // Update swipers after filter change
      requestAnimationFrame(() => {
        updateAllSwipers();
      });
    });
  });

  // Listen for checkbox changes in subfilters
  wrap.addEventListener('change', (e) => {
    if (e.target.type === 'checkbox') {
      // Update swipers after subfilter change
      requestAnimationFrame(() => {
        updateAllSwipers();
      });
    }
  });

  reset?.addEventListener('click', (e) => {
    e.preventDefault();
    items.forEach(el => el.classList.remove('filter-label-wrapper__item--active'));
    groups.forEach(g => g.classList.remove('active'));
    wrap.querySelectorAll('input[type="checkbox"]').forEach(cb => cb.checked = false);

    // Update swipers after reset
    requestAnimationFrame(() => {
      updateAllSwipers();
    });
  });

  // Initial update of swipers
  setTimeout(() => {
    updateAllSwipers();
  }, 200);
}

/* =========================
   FAQ
========================= */
function initFAQ() {
  document.querySelectorAll(".faq-block__item").forEach(item => {
    const content = item.querySelector(".faq-block__content");
    const toggle = item.querySelector(".faq-block__toggle");
    item.addEventListener("click", (e) => {
      const clickedInteractive = e.target.closest('a[href], button, input');
      if (clickedInteractive && !clickedInteractive.closest('.faq-block__header')) return;
      const active = item.classList.contains("faq-block__item--active");
      const parent = item.closest(".faq-block") || item.parentElement;
      parent.querySelectorAll(".faq-block__item--active").forEach(other => {
        if (other !== item) {
          other.classList.remove("faq-block__item--active");
          const otherContent = other.querySelector(".faq-block__content");
          const otherToggle = other.querySelector(".faq-block__toggle");
          if (otherContent) otherContent.style.maxHeight = null;
          if (otherToggle) otherToggle.textContent = "+";
        }
      });
      item.classList.toggle("faq-block__item--active");
      content.style.maxHeight = active ? null : content.scrollHeight + "px";
      toggle.textContent = active ? "+" : "–";
    });
  });
}

/* =========================
   Add to basket (cards) — EXCLUSIVE OPEN
========================= */
function initBasketForm() {
  document.querySelectorAll('.products-list-block__product-form-submit').forEach(button => {
    const form = button.closest('.products-list-block__product-form');
    const main = form.querySelector('.products-list-block__product-form-main');
    const variantInputs = form.querySelectorAll('input[type="radio"]');
    const variantCount = parseInt(form.dataset.variantCount) || variantInputs.length;
    const hasMultipleVariants = variantCount > 1;

    // Helper function to check if we're on mobile
    const isMobile = () => window.innerWidth < 1024;

    // Desktop behavior: Mouse enter - open the form only if multiple variants
    button.addEventListener('mouseenter', function (e) {
      // Only work on desktop and if has multiple variants
      if (isMobile() || !hasMultipleVariants) return;

      e.preventDefault();
      e.stopPropagation();

      const form = this.closest('.products-list-block__product-form');
      const main = form.querySelector('.products-list-block__product-form-main');

      if (!main.classList.contains('active')) {
        const scope = form.closest('.products-list-block') || document;
        scope.querySelectorAll('.products-list-block__product-form-main.active').forEach(el => {
          if (el !== main) el.classList.remove('active');
        });
        scope.querySelectorAll('.products-list-block__product-form-submit.active').forEach(el => {
          if (el !== this) el.classList.remove('active');
        });

        main.classList.add('active');
        this.classList.add('active');
      }
    });

    // Desktop behavior: Mouse leave - close the form (only if multiple variants)
    if (hasMultipleVariants) {
      form.addEventListener('mouseleave', function (e) {
        // Only work on desktop
        if (isMobile()) return;

        setTimeout(() => {
          main.classList.remove('active');
          button.classList.remove('active');
        }, 100);
      });
    }

    // Click handler - different behavior for mobile vs desktop
    button.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const quantityInput = form.querySelector('input[name="quantity"]');
      const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
      let variantId;

      if (isMobile()) {
        if (!main.classList.contains('active')) {
          main.classList.add('active');
          this.classList.add('active');
          return;
        }
      } else if (hasMultipleVariants) {
        if (!main.classList.contains('active')) {
          return;
        }
      }

      if (hasMultipleVariants) {
        const selected = form.querySelector('input[type="radio"]:checked');
        if (!selected) {
          alert('Please select a size/variant');
          return;
        }
        variantId = selected.value;
      } else {
        variantId = variantInputs[0] ? variantInputs[0].value : null;
        if (!variantId) {
          alert('Product variant not found');
          return;
        }
      }
      main.classList.remove('active');
      this.classList.remove('active');
      this.textContent = 'ADDING...';
      this.disabled = true;

      const parsedId = parseInt(variantId, 10);
      console.log('[cart/add] variantId:', variantId, '→', parsedId, 'qty:', quantity);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parsedId, quantity: parseInt(quantity, 10) })
      })
        .then(r => r.json().then(data => { if (!r.ok) throw new Error(data.description || data.message || 'Failed to add to basket'); return data; }))
        .then(async (addedItem) => {
          this.textContent = 'ADD TO BASKET'; this.disabled = false;
          main.classList.remove('active'); this.classList.remove('active');

          setTimeout(() => {
            if (quantityInput) quantityInput.value = 1;
            form.querySelectorAll('input[type="radio"]').forEach(r => r.checked = false);
          }, 1000);

          // Update cart display and count
          console.log('About to update cart display...');
          if (typeof updateCartDisplay === 'function') {
            await updateCartDisplay();
          } else {
            console.error('updateCartDisplay function not found');
          }

          // Get fresh cart data for accurate count
          try {
            const cartResponse = await fetch('/cart.js');
            const cartData = await cartResponse.json();
            console.log('Fresh cart data for count:', cartData.item_count);
            if (typeof updateCartCount === 'function') {
              updateCartCount(cartData.item_count);
            }
          } catch (error) {
            console.error('Error fetching cart data:', error);
          }          // Show success notification
          showCartNotification('Product added to cart!', 'success');

          // Open cart to show the added item
          const cart = document.querySelector('.cart');
          if (cart) {
            cart.classList.add('active');
            document.body.classList.add('cart-open');
          }
        })
        .catch(err => {
          console.error(err);
          this.textContent = 'ADD TO BASKET';
          this.disabled = false;
          alert('Error adding product to cart. Please try again.');
        });
    });
  });

  // Mobile: Click outside to close popup
  document.addEventListener('click', function (e) {
    if (window.innerWidth >= 1024) return; // Only on mobile

    // Check if click is outside any product form
    if (!e.target.closest('.products-list-block__product-form')) {
      document.querySelectorAll('.products-list-block__product-form-main.active').forEach(el => {
        el.classList.remove('active');
        const button = el.closest('.products-list-block__product-form').querySelector('.products-list-block__product-form-submit');
        if (button) button.classList.remove('active');
      });
    }
  });
}



/* =========================
   Quantity controls (cards)
========================= */
function initQuantityControls() {
  document.querySelectorAll('.products-list-block__product-form-quantity-controls').forEach(control => {
    const input = control.querySelector('.products-list-block__quantity-value');
    const incBtn = control.querySelector('.products-list-block__quantity-increment');
    const decBtn = control.querySelector('.products-list-block__quantity-decrement');
    const change = (e, delta) => { e.preventDefault(); let v = parseInt(input.value, 10) || 1; v = Math.max(1, v + delta); input.value = v; input.setAttribute('value', v); };
    incBtn.addEventListener('click', (e) => change(e, 1));
    decBtn.addEventListener('click', (e) => change(e, -1));
  });

  document.querySelectorAll('.products-list-block__product-form-quantity').forEach(el => {
    el.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); });
  });
}

/* =========================
   Generic popup + signup popup
========================= */
function initPopup() {
  const openPopupBtn = document.getElementById('open-popup');
  const closePopupBtn = document.getElementById('close-popup');
  openPopupBtn?.addEventListener('click', () => document.body.classList.add('popup-visible'));
  closePopupBtn?.addEventListener('click', () => document.body.classList.remove('popup-visible'));

  const openSignupBtn = document.getElementById('open-signup');
  const closeSignupBtn = document.getElementById('close-signup-popup');
  const signupOverlay = document.getElementById('signup-overlay');
  const signupForm = document.getElementById('signup-form');

  openSignupBtn?.addEventListener('click', () => document.body.classList.add('signup-popup-visible'));
  closeSignupBtn?.addEventListener('click', () => document.body.classList.remove('signup-popup-visible'));
  signupOverlay?.addEventListener('click', () => document.body.classList.remove('signup-popup-visible'));
  signupForm?.addEventListener('submit', (e) => { e.preventDefault(); alert("Hvala! Proverite vašu email adresu."); document.body.classList.remove('signup-popup-visible'); });
}
document.addEventListener('DOMContentLoaded', initPopup);

/* =========================
   Newsletter modal
========================= */
function initNewsletterModal() {
  const all = document.querySelectorAll('#newsletter-popup');
  if (!all.length) return;
  for (let i = 1; i < all.length; i++) all[i].remove();
  const modal = all[0];
  if (modal.dataset.inited === '1') return;
  modal.dataset.inited = '1';

  const open = () => modal.classList.remove('hidden');
  const timer = setTimeout(open, 2000);

  modal.querySelector('#close-newsletter')?.addEventListener('click', () => {
    modal.classList.add('slide-down'); clearTimeout(timer);
    setTimeout(() => (modal.style.display = 'none'), 500);
  }, { once: true });
}

/* =========================
   Background color observer
========================= */
function initBackgroundColorObserver() {
  const sections = document.querySelectorAll(".home-page section");
  const original = Array.from(sections).map(s => getComputedStyle(s).backgroundColor);
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const idx = Array.prototype.indexOf.call(sections, entry.target);
      const prev = sections[idx - 1];
      if (!prev) return;
      if (entry.isIntersecting && entry.intersectionRatio >= 0.65) prev.style.backgroundColor = getComputedStyle(entry.target).backgroundColor;
      else prev.style.backgroundColor = original[idx - 1];
    });
  }, { threshold: 0.65 });
  sections.forEach(s => observer.observe(s));
}

/* =========================
   Journal filter
========================= */
function initJournalFilter() {
  $('#journal-sort-filter').on('change', function () {
    const sortValue = $(this).val();
    const $container = $('#journal-articles-container');
    const $articles = $container.find('.journal-featured-2col-block__item');
    const arr = $articles.toArray();
    arr.sort(function (a, b) {
      switch (sortValue) {
        case 'latest': return parseInt($(b).data('date')) - parseInt($(a).data('date'));
        case 'oldest': return parseInt($(a).data('date')) - parseInt($(b).data('date'));
        case 'title-asc': return String($(a).data('title')).localeCompare(String($(b).data('title')));
        case 'title-desc': return String($(b).data('title')).localeCompare(String($(a).data('title')));
        default: return 0;
      }
    });
    $articles.remove();
    $.each(arr, function (_, article) { $container.append(article); });
    $('.fadein-wrap').removeClass('slide_up').addClass('slide_up');
  });
}

/* =========================
   Locomotive (optional)
========================= */
// function initSmoothScroll() {
//   if (window.innerWidth <= 768) return;
//   if ('ontouchstart' in window || navigator.maxTouchPoints > 0) return;

//   const scroll = new LocomotiveScroll({
//     el: document.querySelector('[data-scroll-container]'),
//     smooth: true,
//     multiplier: 1.0,
//     lerp: 0.1,
//     direction: 'vertical',
//     gestureDirection: 'vertical',
//     reloadOnContextChange: false,
//     touchMultiplier: 2,
//     smoothMobile: false,
//     smartphone: { smooth: false },
//     tablet: { smooth: false }
//   });

//   window.addEventListener('resize', () => scroll.update());
//   const mo = new MutationObserver(() => scroll.update());
//   mo.observe(document.body, { childList: true, subtree: true });
//   window.locomotiveScroll = scroll;
//   return scroll;
// }

/* =========================
   Smooth Scroll for Anchor Links
========================= */
function initSmoothScroll() {
  $('a[href^="#"]').on('click', function (event) {
    var href = this.getAttribute('href');
    if (!href || href === '#') return;
    var target = $(href);
    if (target.length) {
      event.preventDefault();

      // Disable custom smooth scroll during jQuery animation
      if (typeof window.setJQueryAnimating === 'function') {
        window.setJQueryAnimating(true);
      }

      $('html, body').stop().animate({
        scrollTop: target.offset().top - 110 // 150px offset for header
      }, 1000, function () {
        // Re-enable custom smooth scroll after animation completes
        if (typeof window.setJQueryAnimating === 'function') {
          window.setJQueryAnimating(false);
        }

        // Update URL hash
        if (history.pushState) {
          history.pushState(null, null, $(target).attr('id') ? '#' + $(target).attr('id') : '');
        }
      });
    }
  });
}

/* =========================
   Fade-in & Parallax
========================= */
$(window).scroll(function () {
  fadeIn();
  initParallaxElements();
  $('[data-tparallax-allowed]').each($.tParallax);
});

$(window).on("load", function () {
  fadeIn();
  initParallaxElements();
  $('[data-tparallax-allowed]').each($.tParallax);
  $(".intro-1-block__container").addClass("in-view");
  $(".home-slider-image").addClass("in-view");
  $(".gifts-banner-block img").fadeIn();
  $(".gifts-banner-block .gifts-banner-block__wrapper").addClass("in-view");
  $(".wholesale-intro-block__wrapper").addClass("in-view");
});

function fadeIn() {
  var winHeight = $(window).height();
  var bodyScroll = $(document).scrollTop();
  var calcHeight = bodyScroll + winHeight;

  $(".fadein-wrap").each(function () {
    if ($(this).offset().top < calcHeight && $(this).offset().top + $(this).height() > bodyScroll) {
      if (!$(this).hasClass("in-view")) $(this).addClass("in-view");
    }
  });
}

function initParallaxElements() {
  $.tParallax = function (_idx, el) {
    var offset = $(el).offset().top - $(window).height() / 2 - $(window).scrollTop();
    var distance = $(el).data('parallax-distance');
    $(el).css({ 'transform': "translateY(" + offset / distance + "px)" });
  };

  $(window).scroll(function () { $('[data-tparallax-allowed]').each($.tParallax); });
  $(document).ready(function () {
    $('[data-parallax-distance]').each(function () {
      if ($(this).css('transition-duration') != '0s') { console.dir("Parallax element can't have transition duration defined."); return false; }
      if ($(this).data('transition-duration') < 1) { console.dir("Parallax element must have distance at least 1."); return false; }
      $(this).attr('data-tparallax-allowed', '');
    });

    function lerpColor(a, b, t) {
      const ah = a.replace('#', ''), bh = b.replace('#', '');
      const ar = parseInt(ah.substring(0, 2), 16), ag = parseInt(ah.substring(2, 4), 16), ab = parseInt(ah.substring(4, 6), 16);
      const br = parseInt(bh.substring(0, 2), 16), bg = parseInt(bh.substring(2, 4), 16), bb = parseInt(bh.substring(4, 6), 16);
      const rr = Math.round(ar + (br - ar) * t), rg = Math.round(ag + (bg - ag) * t), rb = Math.round(ab + (bb - ab) * t);
      return `rgb(${rr},${rg},${rb})`;
    }

    function initScrollingBlockBgTransition() {
      const section = document.querySelector('.scrolling-block');
      if (!section) return;
      const colorStart = '#EBEBE2';
      const colorEnd = '#DBD198';
      function onScroll() {
        const rect = section.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;
        if (rect.bottom > 0 && rect.top < windowHeight) {
          const sectionHeight = rect.height;
          let progress = (windowHeight - rect.top) / (windowHeight + sectionHeight);
          progress = Math.max(0, Math.min(1, progress));
          section.style.backgroundColor = lerpColor(colorStart, colorEnd, progress);
        } else {
          section.style.backgroundColor = colorStart;
        }
      }
      window.addEventListener('scroll', onScroll);
      window.addEventListener('resize', onScroll);
      onScroll();
    }
    initScrollingBlockBgTransition();
  });
}

/* =========================
   Custom selects
========================= */
function initCustomSelects() {
  document.querySelectorAll(".custom-select").forEach(wrapper => {
    const trigger = wrapper.querySelector(".custom-select__trigger");
    const options = wrapper.querySelectorAll(".custom-option");
    const hiddenInput = wrapper.querySelector("input[type='hidden']");
    trigger.addEventListener("click", () => wrapper.classList.toggle("open"));
    options.forEach(option => option.addEventListener("click", () => {
      trigger.textContent = option.textContent;
      hiddenInput.value = option.dataset.value;
      wrapper.classList.remove("open");
    }));
    document.addEventListener("click", (e) => { if (!wrapper.contains(e.target)) wrapper.classList.remove("open"); });
  });
}

/* =========================
   Product page: buy button / variants
========================= */
function initProductPageBuyButton() {
  document.addEventListener('change', function (e) {
    if (e.target.name === 'id' || e.target.classList.contains('product-variant-selector')) {
      const form = e.target.closest('form');
      const buyButton = form ? form.querySelector('.product-buy-button') : document.querySelector('.product-buy-button');
      if (buyButton) {
        buyButton.dataset.variantId = e.target.value;
        const hidden = form ? form.querySelector('.product-variant-id') : document.querySelector('.product-variant-id');
        if (hidden) hidden.value = e.target.value;
      }
    }
  });

  document.addEventListener('variant:change', function (e) {
    const variant = e.detail.variant;
    const buyButton = document.querySelector('.product-buy-button');
    const hidden = document.querySelector('.product-variant-id');
    if (buyButton && variant) {
      buyButton.dataset.variantId = variant.id;
      if (hidden) hidden.value = variant.id;
      if (variant.available) { buyButton.disabled = false; buyButton.querySelector('span').textContent = 'Add to basket'; }
      else { buyButton.disabled = true; buyButton.querySelector('span').textContent = 'Sold out'; }
    }
  });
}

/* =========================
   Product accordions
========================= */
function initProductAccordions() {
  document.querySelectorAll('.product__accordion details').forEach(accordion => {
    const summary = accordion.querySelector('summary');
    const content = accordion.querySelector('.accordion__content');
    const toggle = accordion.querySelector('.faq-block__toggle');
    if (!summary || !content || !toggle) return;

    let wrapper = accordion.querySelector('.accordion__content-wrapper');
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'accordion__content-wrapper';
      content.parentNode.insertBefore(wrapper, content);
      wrapper.appendChild(content);
    }

    if (accordion.hasAttribute('open')) {
      wrapper.style.maxHeight = content.scrollHeight + 'px'; toggle.textContent = '+'; toggle.style.transform = 'rotate(45deg)';
    } else {
      wrapper.style.maxHeight = '0px'; toggle.textContent = '+'; toggle.style.transform = 'rotate(0deg)';
    }

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      const isOpen = accordion.hasAttribute('open');

      if (isOpen) {
        wrapper.style.maxHeight = '0px'; toggle.textContent = '+'; toggle.style.transform = 'rotate(0deg)';
        setTimeout(() => accordion.removeAttribute('open'), 300);
      } else {
        document.querySelectorAll('.product__accordion details[open]').forEach(other => {
          if (other !== accordion) {
            const ow = other.querySelector('.accordion__content-wrapper');
            const ot = other.querySelector('.faq-block__toggle');
            if (ow && ot) { ow.style.maxHeight = '0px'; ot.textContent = '+'; ot.style.transform = 'rotate(0deg)'; setTimeout(() => other.removeAttribute('open'), 300); }
          }
        });
        accordion.setAttribute('open', '');
        wrapper.style.maxHeight = content.scrollHeight + 'px'; toggle.textContent = '+'; toggle.style.transform = 'rotate(45deg)';
      }
    });
  });
}

/* =========================
   READ MORE (product overview)
========================= */
document.addEventListener('DOMContentLoaded', function () {
  const toggleBtn = document.querySelector('.product__readmore-toggle');
  const desc = document.querySelector('.product-overview-block__description');
  if (!toggleBtn || !desc) return;

  let isExpanded = false;

  function collapsedHeight() {
    const cs = window.getComputedStyle(desc);
    const lh = parseFloat(cs.lineHeight);
    const fs = parseFloat(cs.fontSize);
    const actual = isNaN(lh) ? fs * 1.4 : lh;
    return actual * 3;
  }

  function initReadMore() {
    const h = collapsedHeight();
    desc.style.maxHeight = h + 'px';
    desc.style.overflow = 'hidden';
    desc.style.transition = 'max-height 0.3s ease';

    if (desc.scrollHeight <= h + 10) {
      toggleBtn.style.display = 'none';
      desc.style.maxHeight = 'none';
      return;
    } else {
      toggleBtn.style.display = 'inline-block';
    }

    const btn = toggleBtn.cloneNode(true);
    toggleBtn.parentNode.replaceChild(btn, toggleBtn);

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (isExpanded) {
        desc.style.maxHeight = h + 'px';
        btn.textContent = 'READ MORE';
        isExpanded = false;
      } else {
        desc.style.maxHeight = desc.scrollHeight + 'px';
        btn.textContent = 'SHOW LESS';
        isExpanded = true;
      }
    });
  }

  initReadMore();

  let resizeTimeout;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => { isExpanded = false; initReadMore(); }, 150);
  });
});

/* =========================
   Global: orijentacija/resize – osveži visine swiper-a
========================= */
window.addEventListener('orientationchange', () => {
  document.querySelectorAll('.products-list-block .swiper, .home-collection-block .swiper')
    .forEach(el => el.swiper && (lockSwiperHeight(el.swiper), reservePaginationSpace(el.swiper)));
});

/* ===== No-reload na ponovni klik iste stranice ===== */
(function noReloadOnSamePage() {
  const SELECTOR = 'a[href]';

  function normalizePath(u) {
    let p = u.pathname.replace(/\/+/g, '/').replace(/\/index\.html?$/i, '');
    if (p.length > 1 && p.endsWith('/')) p = p.slice(0, -1);
    return p.toLowerCase();
  }
  function sameLogicalPage(urlA, urlB) {
    return (urlA.origin === urlB.origin) && (normalizePath(urlA) === normalizePath(urlB));
  }

  function disableLink(a) {
    if (a.dataset.noreload === '1') return;
    a.dataset.noreload = '1';
    a.setAttribute('aria-current', a.getAttribute('aria-current') || 'page');

    const handler = function (e) {
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      return false;
    };
    a.addEventListener('click', handler, { capture: true });
    a.addEventListener('click', handler);
  }

  function scan() {
    const current = new URL(window.location.href);
    document.querySelectorAll(SELECTOR).forEach(a => {
      const href = a.getAttribute('href');
      if (!href || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('#')) return;
      if (a.target && a.target !== '_self') return;

      const linkUrl = new URL(href, window.location.origin);
      if (linkUrl.origin !== current.origin) return;

      if (sameLogicalPage(linkUrl, current)) {
        disableLink(a);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else { scan(); }
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', scan);
})();
